/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M2 12C2 14.2516 2.74418 16.3295 4 18.001M22 12C22 9.74879 21.2615 7.67132 20.0104 6"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2 7.5V4M2 7.5C2 7.5 5.33333 2 12 2C15.291 2 18.1921 3.57111 20.0104 6M2 7.5H5.5M21 16.5C21 16.5 17.5228 22 12 22C8.7288 22 5.82446 20.4293 4 18.001M21 16.5H17.5M21 16.5V20"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<circle opacity="0.12" cx="12" cy="12" r="10" fill="currentColor" />
			<path
				d="M2 12C2 17.5228 6.47715 22 12 22C17.5228 22 21 16.5 21 16.5M22 12C22 6.47715 17.5556 2 12 2C5.33333 2 2 7.5 2 7.5M2 7.5V4M2 7.5H5.5M21 16.5H17.5M21 16.5V20"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M2 12C2 17.5228 6.47715 22 12 22C17.5228 22 21 16.5 21 16.5M22 12C22 6.47715 17.5556 2 12 2C5.33333 2 2 7.5 2 7.5M2 7.5V4M2 7.5H5.5M21 16.5H17.5M21 16.5V20"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M2 12C2 14.2516 2.74418 16.3295 4 18.001M22 12C22 9.74879 21.2615 7.67132 20.0104 6M2 7.5V4M2 7.5C2 7.5 5.33333 2 12 2C13.8262 2 15.5323 2.48377 17 3.32943M2 7.5H5.5M21 16.5C21 16.5 17.5228 22 12 22C10.1786 22 8.47087 21.513 7 20.6622M21 16.5H17.5M21 16.5V20"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M2 12C2 17.5228 6.47715 22 12 22C17.5228 22 21 16.5 21 16.5M22 12C22 6.47715 17.5556 2 12 2C5.33333 2 2 7.5 2 7.5M2 7.5V4M2 7.5H5.5M21 16.5H17.5M21 16.5V20"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				d="M2 12C2 17.5228 6.47715 22 12 22C17.5228 22 21 16.5 21 16.5M22 12C22 6.47715 17.5556 2 12 2C5.33333 2 2 7.5 2 7.5M2 7.5V4M2 7.5H5.5M21 16.5H17.5M21 16.5V20"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
]);
